export interface UpsertProps {
  type: "coordinator" | "member" | "manager";
}

export interface deviceInterface {
  serialnumber: string;
  user: string;
  type: string;
  assigned: boolean;
  orderDate: boolean;
  lot: string;
}

export interface FormInterface {
  email: string;
  firstname: string;
  lastname: string;
  password: string;
  phone: string;
  estimatedGraduation: string;
  group: string;
  program: string;
  site: string;
  externId: string;
  gender: string;
  dob: string;
  feet: string;
  inches: string;
  units: string;
  glucose: string;
  pushURL: string;
  delivery: string;
  state: string;
  status: string;
  "Blood Glucose Monitor": boolean;
  "Blood Pressure Monitor": boolean;
  "Pulse Oxygen Monitor": boolean;
  "Weight Scale": boolean;
  Spirometer: boolean;
  Thermometer: boolean;
  "Cellular Hub": boolean;
  "Smart Hub": boolean;
  imeiValue?: string;
}

// Templates
export const orderBody = {
  organization: "test",
  delivery: "Ground",
  issuedBy: "Current Coordinator",
  issuedEmail: "currentcoord@here.com",
  sendersAddress: {
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: ""
  },
  recipient: {
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: ""
  },
  manifest: {
    devices: {
      bpm: 2,
      bgm: 1,
      scale: 1,
      pulseOx: 1,
      thermometer: 1,
      spirometer: 1
    },
    hubs: {
      stel: 1,
      smart: 1
    }
  }
};
